import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const myWorkContactRelationDataClassName =
  DataClassName.MY_WORK_CONTACT_RELATION
const myWorkContactRelationEndpoint = PisaDataClassEndpoint.MY_WORK_CONTACT

export function pisaMyWorkContactRelationDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(myWorkContactRelationDataClassName, {
    title: myWorkContactRelationDataClassName,
    restApi: createPisaRestApiConfig(myWorkContactRelationEndpoint),
    attributes,
  })
}
